// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___wc0We","root__group":"style-module__root__group___ijIIu","root__group_item":"style-module__root__group_item___u1PHr","root__content":"style-module__root__content___XFM0l","root__icon":"style-module__root__icon___fmwF4","root__title":"style-module__root__title___xPXdm","root__text":"style-module__root__text___J7roP","root__address":"style-module__root__address___T9dFo","root__phone":"style-module__root__phone___EnSTb"};
    if(module.hot) {
      // 1744730399965
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  